import React, { useEffect } from "react";
import DashboardLayout from "../../components/SharedLayouts/DashboardLayout";
import UserCard from "../../components/cards/UserCard";
import { useDispatch, useSelector } from "react-redux";

import CustomButton from "../../components/Buttons/Button";
import { Link, useNavigate } from "react-router-dom";
import useCurrency from "../../hooks/useCurrency";
import RadioGroup from "./Components/RadioGroup";
import RadioGroupFrom from "./Components/RadioGroup";
import { useFormik } from "formik";
import SelectField from "../../components/inputs/SelectField";
import CustomInput from "../../components/inputs/CustomInput";

const CRC = () => {
  // const dispatch = useDispatch();
  // const { investmentMetrics } = useSelector((state) => state?.investment);

  // const currency = useSelector((state) => state.dashboard.currency) || "NGR";

  // const [_currency, getAmount] = useCurrency();

  // const user = useSelector((state) => state.onboarding.user);

  // const navigate = useNavigate();

  const CRCType = ["Consumer", "Commercial"];

  const form = useFormik({
    initialValues: {
      crcType: "Consumer",
      product: {
        value: "Corporate Classic Report",
        label: "Corporate Classic Report",
      },
      searchType: {
        value: "Account Number Search",
        label: "Account Number Search",
      },
    },
    onSubmit: (values) => {},
  });

  return (
    <DashboardLayout>
      <div className="px-4 md:px-8">
        <div className="flex items-center mb-4 md:flex-row md:items-center w-full">
          <Link to={"/dashboard"}>
            <img src="/Assets/bread.png" alt="" className="w-8 h-8 mr-1" />
          </Link>
          <img src="/Assets/chev.png" alt="" className="w-8 h-8 mr-1" />

          <div className=" font-semibold text-[#475467] text-sm sm:text-base bg-[#F9FAFB] p-1 px-3 rounded-md  ">
            CRC
          </div>
        </div>

        <div className="">
          <div className="pb-5 border-b border-b-[#EAECF0]">
            <RadioGroupFrom
              options={CRCType}
              id={"crcType"}
              form={form}
              label={"Select CIR Type"}
            />
          </div>
          <div className="w-full gap-20 flex mt-10">
            <div className="flex-1 max-w-[350px]">
              <label className="text-sm font-[600] text-[#344054]">
                Search Type
              </label>
              <div className="w-full mb-4">
                <SelectField
                  label="Search Type"
                  id="searchType"
                  form={form}
                  options={[
                    {
                      value: "Account Number Search",
                      label: "Account Number Search",
                    },
                    {
                      value: "Contact Number Search",
                      label: "Contact Number Search",
                    },
                    { value: "Name/ID Search", label: "Name/ID Search" },
                    { value: "BVN Search", label: "BVN Search" },
                  ]}
                  sx={{ width: "100%", height: "50px" }}
                />
              </div>
              <label className="text-sm font-[600] text-[#344054]">
                Routing Number
              </label>
              <div className="w-full mb-4">
                <CustomInput
                  // width="400px"
                  fullWidth
                  height="18px"
                  id="routing_number"
                  // type={"number"}
                  form={form}
                  placeholder={"Enter your Routing Number"}
                  borderColor="#D0D5DD"
                  mt="10px"
                  pt="28px"
                />
              </div>
              <label className="text-sm font-[600] text-[#344054]">
                Routing Number
              </label>
              <div className="w-full mb-4">
                <CustomInput
                  // width="400px"
                  fullWidth
                  height="18px"
                  id="routing_number"
                  // type={"number"}
                  form={form}
                  placeholder={"Enter your Routing Number"}
                  borderColor="#D0D5DD"
                  mt="10px"
                  pt="28px"
                />
              </div>{" "}
              <label className="text-sm font-[600] text-[#344054]">
                Routing Number
              </label>
              <div className="w-full mb-4">
                <CustomInput
                  // width="400px"
                  fullWidth
                  height="18px"
                  id="routing_number"
                  // type={"number"}
                  form={form}
                  placeholder={"Enter your Routing Number"}
                  borderColor="#D0D5DD"
                  mt="10px"
                  pt="28px"
                />
              </div>
            </div>
            <div className="flex-1 max-w-[350px]">
              <label className="text-sm font-[600] text-[#344054]">
                Product
              </label>
              <div className="w-full mb-4">
                <SelectField
                  label="Select Product"
                  id="product"
                  form={form}
                  options={[
                    {
                      value: "Corporate Classic Report",
                      label: "Corporate Classic Report",
                    },
                    {
                      value: "Corporate Basic Report",
                      label: "Corporate Basic Report",
                    },
                  ]}
                  sx={{ width: "100%", height: "50px" }}
                />
              </div>
              <label className="text-sm font-[600] text-[#344054]">
                Product
              </label>
              <div className="w-full mb-4">
                <SelectField
                  label="Select Product"
                  id="product"
                  form={form}
                  options={[
                    {
                      value: "Corporate Classic Report",
                      label: "Corporate Classic Report",
                    },
                    {
                      value: "Corporate Basic Report",
                      label: "Corporate Basic Report",
                    },
                  ]}
                  sx={{ width: "100%", height: "50px" }}
                />
              </div>

              <label className="text-sm font-[600] text-[#344054]">
                Routing Number
              </label>
              <div className="w-full mb-4">
                <CustomInput
                  // width="400px"
                  fullWidth
                  height="18px"
                  id="routing_number"
                  // type={"number"}
                  form={form}
                  placeholder={"Enter your Routing Number"}
                  borderColor="#D0D5DD"
                  mt="10px"
                  pt="28px"
                />
              </div>
              <label className="text-sm font-[600] text-[#344054]">
                Product
              </label>
              <div className="w-full mb-4">
                <SelectField
                  label="Select Product"
                  id="product"
                  form={form}
                  options={[
                    {
                      value: "Corporate Classic Report",
                      label: "Corporate Classic Report",
                    },
                    {
                      value: "Corporate Basic Report",
                      label: "Corporate Basic Report",
                    },
                  ]}
                  sx={{ width: "100%", height: "50px" }}
                />
              </div>
            </div>
          </div>
          <div className="flex justify-center w-[780px] items-center">
            <CustomButton
              loading={form?.isSubmitting}
              variant="contained"
              customColor="#159AA8"
              children="Search"
              width="250px"
              height="45px"
              padding="10px"
              margin="15px 0"
              color="#fff"
              onClick={form.handleSubmit}
            />
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};
export default CRC;
